//imports
import { HashRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Hourlystats from "./pages/hourlystats/Hourlystats";
import ErrorBoundary from "./components/ErrorBoundary";
function App() {
  return (
    <ErrorBoundary>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/hourlystats" element={<Hourlystats />} />
        </Routes>
      </HashRouter>
    </ErrorBoundary>
  );
}
export default App;
